module.exports = "/_next/static/images/mitra-1-8468e1f38bde87c901c009e20aed29d4.jpeg";